
import PropTypes from 'prop-types'
import React from 'react'
import { Form, TextField, InputField } from '@segment/react-forms'
import { FlexGrid, FlexItem } from 'ui/flexgrid'
import Space from 'ui/Space'
import Button from 'ui/Button'
import {
  validateUsername,
  validatePassword,
  validateHost,
  validatePort,
  validateDatabaseName
} from '../../utils/validators'

const WarehouseSetupConnectForm = props => (
  <Form onSubmit={props.onSubmit}>
    <TextField
      value={props.username}
      onInput={e => props.onEnterUsername(e.target.value)}
      disabled={props.isSubmitting}
      validationMessage={validateUsername}
      label='Username'
      name='username'
      required />

    <InputField
      value={props.password}
      onInput={e => props.onEnterPassword(e.target.value)}
      disabled={props.isSubmitting}
      validationMessage={validatePassword}
      label='Password'
      name='password'
      type='password'
      required />

    <TextField
      value={props.host}
      onInput={e => props.onEnterHost(e.target.value)}
      validationMessage={validateHost}
      disabled={props.isSubmitting}
      label='Host'
      name='host'
      required />

    <Space value='20' />

    <FlexGrid>
      <FlexItem spaceRight='20' flex='1'>
        <TextField
          value={props.port}
          onInput={e => props.onEnterPort(e.target.value)}
          validationMessage={validatePort}
          disabled={props.isSubmitting}
          label='Port'
          name='port'
          required />
      </FlexItem>
      <FlexItem flex='1'>
        <TextField
          value={props.database}
          onInput={e => props.onEnterDatabase(e.target.value)}
          validationMessage={validateDatabaseName}
          disabled={props.isSubmitting}
          label='Database name'
          name='database'
          required />
      </FlexItem>
    </FlexGrid>

    <Space value='40' />

    <Button type='submit' extras='fluid' disabled={!props.isValid || props.isSubmitting}>Connect</Button>
  </Form>
)

WarehouseSetupConnectForm.displayName = 'WarehouseSetupConnectForm'

WarehouseSetupConnectForm.propTypes = {
  database: PropTypes.string.isRequired,
  host: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  onEnterDatabase: PropTypes.func.isRequired,
  onEnterHost: PropTypes.func.isRequired,
  onEnterPassword: PropTypes.func.isRequired,
  onEnterPort: PropTypes.func.isRequired,
  onEnterUsername: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  port: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  username: PropTypes.string.isRequired
}

export default WarehouseSetupConnectForm



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-setup-connect-form/index.js